import { render, staticRenderFns } from "./candidateInformation.vue?vue&type=template&id=fb2817e4&scoped=true&"
import script from "./candidateInformation.vue?vue&type=script&lang=js&"
export * from "./candidateInformation.vue?vue&type=script&lang=js&"
import style0 from "./candidateInformation.vue?vue&type=style&index=0&id=fb2817e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb2817e4",
  null
  
)

export default component.exports